import { html } from '../core/html.js';
import { t } from '../core/i18n.js';
import { routeHref } from '../core/url.js';
import { site } from '../data/site.js';
import { icon } from './icon.js';

/** Full-width slate-blue closing block. Keys and contact target can be overridden per context. */
export const ctaSection = ({
  labelKey = 'cta.label',
  titleKey = 'cta.title',
  ledeKey = 'cta.lede',
  buttonKey = 'cta.button',
  href = null,
  email = site.email,
} = {}) => html`
  <section class="cta" aria-labelledby="cta-title">
    <div class="shell cta__inner">
      <div>
        <p class="cta__label">${t(labelKey)}</p>
        <h2 class="cta__title" id="cta-title">${t(titleKey)}</h2>
      </div>
      <div class="cta__side">
        <p class="cta__lede">${t(ledeKey)}</p>
        <div class="cta__actions">
          <a class="btn btn--paper btn--lg" href="${href ?? routeHref('/contact')}">
            ${t(buttonKey)}${icon('arrowRight', { size: 17 })}
          </a>
          <a class="cta__mail" href="mailto:${email}">${email}</a>
        </div>
      </div>
    </div>
  </section>
`;
